import { LDFlagSet } from 'launchdarkly-js-sdk-common';

export enum EXPENSE_TYPE {
  BOARD = 'BOARD',
  BODY_CORPORATE_FEES_STRATA_FEES_AND_LAND_TAX = 'BODY_CORPORATE_FEES_STRATA_FEES_AND_LAND_TAX',
  CHILDCARE = 'CHILDCARE',
  CHILD_AND_SPOUSAL_MAINTENANCE = 'CHILD_AND_SPOUSAL_MAINTENANCE',
  CLOTHING_AND_PERSONAL_CARE = 'CLOTHING_AND_PERSONAL_CARE',
  GROCERIES = 'GROCERIES',
  HEALTH_INSURANCE = 'HEALTH_INSURANCE',
  HIGHER_VOCATIONAL_TRAINING_EDUCATION = 'HIGHER_VOCATIONAL_TRAINING_EDUCATION',
  INSURANCE = 'INSURANCE',
  INVESTMENT_PROPERTY_RUNNING_COSTS = 'INVESTMENT_PROPERTY_RUNNING_COSTS',
  LIFE_INSURANCE = 'LIFE_INSURANCE',
  LIVING_EXPENSES_ESTIMATE = 'LIVING_EXPENSES_ESTIMATE',
  MEDICAL_AND_HEALTH = 'MEDICAL_AND_HEALTH',
  OTHER = 'OTHER',
  PET_CARE = 'PET_CARE',
  PRIMARY_RESIDENCE_RUNNING_COSTS = 'PRIMARY_RESIDENCE_RUNNING_COSTS',
  PRIMARY_SECONDARY_EDUCATION = 'PRIMARY_SECONDARY_EDUCATION',
  PRIVATE_SCHOOLING_AND_TUITION = 'PRIVATE_SCHOOLING_AND_TUITION',
  RECREATION_AND_ENTERTAINMENT = 'RECREATION_AND_ENTERTAINMENT',
  RENT = 'RENT',
  RENT_UTILITIES = 'RENT_UTILITIES',
  SECONDARY_RESIDENCE_RUNNING_COSTS = 'SECONDARY_RESIDENCE_RUNNING_COSTS',
  TELEPHONE_INTERNET_PAY_TV_AND_MEDIA_STREAMING_SUBSCRIPTIONS = 'TELEPHONE_INTERNET_PAY_TV_AND_MEDIA_STREAMING_SUBSCRIPTIONS',
  TRANSPORT = 'TRANSPORT',
  STRATA_BODY_CORPORATE_FEES = 'STRATA_BODY_CORPORATE_FEES',
  LAND_TAX = 'LAND_TAX',
}

export enum EXPENSE_GROUP_TYPE {
  PERSONAL = 'PERSONAL_GROUP',
  HOUSEHOLD = 'HOUSEHOLD_GROUP',
  CHILD_AND_SPOUSE = 'CHILD_AND_SPOUSE_GROUP',
  EDUCATION = 'EDUCATION_GROUP',
  INSURANCE = 'INSURANCE_GROUP',
  PROPERTY = 'PROPERTY_GROUP',
  OTHER = 'OTHER_GROUP',
  ALL = 'ALL_GROUP',
}

export const EXPENSES_ALL: (flags: LDFlagSet) => { [key: string]: any } = (flags) =>
  Object.values(EXPENSE_TYPE).filter((t) => (flags.rentInvestExpenses ? true : t !== EXPENSE_TYPE.RENT_UTILITIES));

export const EXPENSES_GROUP: (flags: LDFlagSet) => { [key: string]: any } = (flags) => ({
  [EXPENSE_GROUP_TYPE.PERSONAL]: [
    EXPENSE_TYPE.CLOTHING_AND_PERSONAL_CARE,
    EXPENSE_TYPE.MEDICAL_AND_HEALTH,
    EXPENSE_TYPE.RECREATION_AND_ENTERTAINMENT,
    EXPENSE_TYPE.TRANSPORT,
  ],
  [EXPENSE_GROUP_TYPE.HOUSEHOLD]: [
    EXPENSE_TYPE.GROCERIES,
    EXPENSE_TYPE.PET_CARE,
    EXPENSE_TYPE.TELEPHONE_INTERNET_PAY_TV_AND_MEDIA_STREAMING_SUBSCRIPTIONS,
    ...(flags.rentInvestExpenses ? [EXPENSE_TYPE.RENT_UTILITIES] : []),
    EXPENSE_TYPE.PRIMARY_RESIDENCE_RUNNING_COSTS,
    EXPENSE_TYPE.BODY_CORPORATE_FEES_STRATA_FEES_AND_LAND_TAX,
    EXPENSE_TYPE.SECONDARY_RESIDENCE_RUNNING_COSTS,
    EXPENSE_TYPE.INVESTMENT_PROPERTY_RUNNING_COSTS,
  ],
  [EXPENSE_GROUP_TYPE.CHILD_AND_SPOUSE]: [EXPENSE_TYPE.CHILD_AND_SPOUSAL_MAINTENANCE, EXPENSE_TYPE.CHILDCARE],
  [EXPENSE_GROUP_TYPE.EDUCATION]: [
    EXPENSE_TYPE.PRIMARY_SECONDARY_EDUCATION,
    EXPENSE_TYPE.HIGHER_VOCATIONAL_TRAINING_EDUCATION,
    EXPENSE_TYPE.PRIVATE_SCHOOLING_AND_TUITION,
  ],
  [EXPENSE_GROUP_TYPE.INSURANCE]: [EXPENSE_TYPE.INSURANCE, EXPENSE_TYPE.HEALTH_INSURANCE, EXPENSE_TYPE.LIFE_INSURANCE],
  [EXPENSE_GROUP_TYPE.PROPERTY]: [],
  [EXPENSE_GROUP_TYPE.OTHER]: [EXPENSE_TYPE.OTHER, EXPENSE_TYPE.RENT, EXPENSE_TYPE.BOARD],
  [EXPENSE_GROUP_TYPE.ALL]: EXPENSES_ALL(flags),
});

export const EXPENSE_PROPERTY_RELATED_EXPENSES = [
  EXPENSE_TYPE.PRIMARY_RESIDENCE_RUNNING_COSTS,
  EXPENSE_TYPE.BODY_CORPORATE_FEES_STRATA_FEES_AND_LAND_TAX,
  EXPENSE_TYPE.SECONDARY_RESIDENCE_RUNNING_COSTS,
  EXPENSE_TYPE.INVESTMENT_PROPERTY_RUNNING_COSTS,
];

export enum PROPERTY_EXPENSE_TYPE {
  BODY_CORPORATE_FEES_STRATA_FEES_AND_LAND_TAX = 'BODY_CORPORATE_FEES_STRATA_FEES_AND_LAND_TAX',
  INVESTMENT_PROPERTY_RUNNING_COSTS = 'INVESTMENT_PROPERTY_RUNNING_COSTS',
  PRIMARY_RESIDENCE_RUNNING_COSTS = 'PRIMARY_RESIDENCE_RUNNING_COSTS',
  SECONDARY_RESIDENCE_RUNNING_COSTS = 'SECONDARY_RESIDENCE_RUNNING_COSTS',
  STRATA_BODY_CORPORATE_FEES = 'STRATA_BODY_CORPORATE_FEES',
  LAND_TAX = 'LAND_TAX',
}

export const PROPERTY_EXPENSES = [
  PROPERTY_EXPENSE_TYPE.BODY_CORPORATE_FEES_STRATA_FEES_AND_LAND_TAX,
  PROPERTY_EXPENSE_TYPE.INVESTMENT_PROPERTY_RUNNING_COSTS,
  PROPERTY_EXPENSE_TYPE.PRIMARY_RESIDENCE_RUNNING_COSTS,
  PROPERTY_EXPENSE_TYPE.SECONDARY_RESIDENCE_RUNNING_COSTS,
  PROPERTY_EXPENSE_TYPE.STRATA_BODY_CORPORATE_FEES,
  PROPERTY_EXPENSE_TYPE.LAND_TAX,
];
